module.exports = __webpack_public_path__ + "static/img/image-box.93e1d6ce.jpg";